export default {
  manage_createEditCrew_success: "Crew was created successfully",
  manage_createEditCrew_success_edit: "Crew was updated successfully",
  manage_createEditCrew_FirstNameInputLabel: "First name",
  manage_createEditCrew_LastNameInputLabel: "Last name",
  manage_createEditCrew_VehicleInputLabel: "Vehicle",
  manage_createEditCrew_VehicleInputLabel: "Vehicle",
  manage_createEditCrew_CreateTitle: "Add Crew Member",
  manage_createEditCrew_EditTitle: "Edit Crew Member",
  manage_createEditCrew_EditForTitle: "Edit Crew Members for",
  manage_createEditCrew_members: "Crew Members",
  manage_createEditCrew_ReAssignTitle: "Re-Assign",
  manage_createEditCrew_AssignTitle: "Assign",
  manage_createEditCrew_ToTitle: "to",
  manage_createEditCrew_duplicatedCrewErrorMessage: "This Crew already exists"
};
